import { render } from "./BirthDetail.vue?vue&type=template&id=51a37f26&scoped=true"
import script from "./BirthDetail.vue?vue&type=script&lang=js"
export * from "./BirthDetail.vue?vue&type=script&lang=js"

import "./BirthDetail.vue?vue&type=style&index=0&id=51a37f26&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a37f26"]])

export default __exports__